<template>
    <div class="invitationCode">
        <van-popup
            v-model="show"
            closeable
            close-icon="close"
            position="bottom"
            :close-on-click-overlay='false'
            :style="{ height: '35%' }"
        >
            <div class="content">
                <div class="title">请在下方输入商家邀请码</div>
                <div class="input">
                    <van-field type="text" v-model="invitationCode" placeholder="请输入商家邀请码" />
                    <p>请输入商家邀请码，查看商品详情～</p>
                </div>
                <div class="btn">
                    <p @click="onSubmit"><van-button  color="#FF7A45" :round="true" type="default">确认</van-button></p>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
import { Toast } from 'vant'
export default {
    name: 'invitationCode',
    data () {
        return {
            invitationCode: '',
            show: false
        }
    },
    methods: {
        ...mapActions(['addCompany', 'getUserInfoData']),
        async onSubmit () {
            if (!this.invitationCode) {
                Toast('请输入商家邀请码')
                return false
            }
            await this.addCompany({
                companyCode: this.userInfo.companyCode,
                invitationCode: this.invitationCode
            }).then(async (data) => {
                await this.getUserInfoData()
                Toast({
                    message: '保存成功',
                    duration: 2000
                })
                setTimeout(() => {
                    this.$emit('submitCode')
                    this.show = false
                }, 2000)
            })
        },
        init () {
            this.show = true
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.invitationCode = this.userInfo.belongMerchantInviteCode
    }
}
</script>
<style lang="scss" scoped>
    .content{
        padding: 32px;
        .title{
            font-size: 34px;
            color: #333333;
        }
        .input{
            margin-top: 48px;
            font-size: 32px;
            p{
                font-size: 26px;
                color: #FF7A45;
                margin-top: 16px;
            }
        }
        .btn{
            margin-top: 54px;
        }
    }
    /deep/ .van-button--normal {
        width: 100%;
        height: 96px;
        line-height: 96px;
        font-size: 32px;
    }
    /deep/ .van-button--default{
        border: 2px solid rgb(255, 122, 69);
    }
    /deep/ .van-popup__close-icon{
        font-size: 48px;
    }
    /deep/ .van-popup__close-icon--top-right{
        top: 32px;
    }
</style>
